import useApiCall from "@hooks/Shared/useApiCall";
import { IMedia } from "@interfaces/Media/Media";

const useGetMedia = (mediaId: string) =>
  useApiCall<IMedia>({
    url: `/media/${mediaId}`,
  });

export default useGetMedia;
